import { render, staticRenderFns } from "./event-item.vue?vue&type=template&id=5602f155&"
import script from "./event-item.vue?vue&type=script&lang=js&"
export * from "./event-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports